<a class="ou-get-back" (click)="back()">
  <mat-icon class="material-icons-outlined">arrow_back_ios</mat-icon>
  <div class="ou-get-back-title">{{organizationUnit.niceName}}</div>
</a>
<div class="edit-ou-container">
  <mat-accordion class="ticket-list" multi>
    <mat-expansion-panel class="edit-container">
      <mat-expansion-panel-header
        (click)="$event.stopPropagation()"
        [collapsedHeight]="'30px'"
        [expandedHeight]="'30px'"
      >
        Szervezeti egység adatok
      </mat-expansion-panel-header>
      <div class="ou-details">
        <div class="ou-details-flex">
          <div>Szervezeti egység neve:</div>
          <div> {{organizationUnit.niceName}}</div>
          <app-button [icon]="'edit'" [customColor]="'yellow'" (click)="update()"></app-button>
        </div>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel class="edit-container">
      <mat-expansion-panel-header
        (click)="$event.stopPropagation()"
        [collapsedHeight]="'30px'"
        [expandedHeight]="'30px'"
      >
        Rétegmenedzsment
      </mat-expansion-panel-header>
      <h4 class="black">Rétegek eltávolítása:</h4>
      <div class="ou-layer-remove">
        <div
        *ngFor="let layer of organizationUnit.externalLayers"
        class="ou-layer-remove-item"
        (click)="removeLayer(layer)"
        >
          <div>{{getPath(layer)}}</div>
          <div>{{layer.name}}</div>
        </div>
      </div>
      <h4 class="black">Rétegek hozzáadása:</h4>
      <div class="ou-layer-connector">
        <div class="ou-layer-folder">
          <h4>Mappalista:</h4>
          <div *ngFor="let item of folderList.folders;">
            <div
              [class.active]="selectedFolder === item"
              (click)="selectFolder(item)"
              class="ou-layer-item"  
            >{{item}}</div>
          </div>
        </div>
        <div class="ou-layer-folder-separator">
          <mat-icon class="material-icons-outlined">double_arrow</mat-icon>
        </div>
        <div class="ou-layer-folder">
          <h4>Service lista:</h4>
          <div *ngIf="selectedFolder.length > 0">
            <div *ngFor="let item of serviceList.services;">
              <div
                [class.active]="selectedService.name === item.name"
                (click)="selectService(item)"
                class="ou-layer-item"
              >
                {{item.name}} - {{item.type}}
              </div>
            </div>
          </div>
        </div>
        <div class="ou-layer-folder-separator">
          <mat-icon class="material-icons-outlined">double_arrow</mat-icon>
        </div>
        <div class="ou-layer-folder">
          <h4>Hozzáadható rétegek:</h4>
          <div *ngIf="layerList.layers.length > 0">
            <div *ngFor="let item of layerList.layers;">
              <div *ngIf="!isLayerAddedToOu(selectedService, item)">
                <div class="ou-layer-item" (click)="addLayer(item)">{{item.name}} - {{item.type}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>